import React, { useState } from "react";
import { AgChartsReact } from "ag-charts-react";

function getData() {
  return [
    { type: "Arun", earnings: 117 },
    { type: "Sujith", earnings: 90 },
    { type: "Ramde", earnings: 50 },
    { type: "Keyur", earnings: 90 },
    { type: "Mohit", earnings: 80 },
    { type: "Dhruvi", earnings: 117 },
    { type: "Ramde A", earnings: 50 },
    { type: "Keyur B", earnings: 90 },
    { type: "Mohit C", earnings: 80 },
    { type: "Dhruvi D", earnings: 40 },
  ];
}

export default function ChartDesigner() {
  const [options, setOptions] = useState({
    autoSize: true,
    data: getData(),
    theme: {
        baseTheme: "ag-default-dark",
      overrides: {
        
        bar: {
          series: {
            strokeWidth: 0,
          },
        },
      },
    },
    title: {
      text: 'Request Assigned to Designer',
      fontSize: 18,
      spacing: 25,
      textAlign: 'left'
    },
    series: [
      {
        type: "bar",
        xKey: "type",
        yKey: "earnings",
      },
    ],
    axes: [
      {
        type: "category",
        position: "left",
      },
      {
        type: "number",
        position: "bottom",
      },
    ],
    legend: {
      enabled: false,
    },
  });

  return <AgChartsReact options={options} />;
}
